/* eslint-disable react/jsx-props-no-spreading, react/prop-types, import/no-cycle */
import React from "react"
import LandingBanner from "./blocks/landing-banner"
import ThreeColumnItem from "./blocks/three-column-item"
import ImageTitleContentButton from "./blocks/image-title-content-button"
import ImageBanner from "./blocks/image-banner"
import EmptyBlock from "./blocks/empty-block"
import TitleContentBanner from "./blocks/title-content-banner"
import VenueArchive from "./blocks/venue-archive"
import VenueInteractive from "./blocks/venue-interactive"
import TeamValueSlider from "./blocks/team-value-slider"
import StepValue from "./blocks/step-value"
import Contact from "./blocks/contact"
import ThankYou from "./blocks/thank-you"
import PromoTestimonialBlock from "./blocks/promo-testimonial-block"
import AvailableJob from "./blocks/available-job"
import AvailableFacility from "./blocks/available-facility"
import AvailableSpace from "./blocks/available-space"
import EventSelector from "./blocks/event-selector"
import Embed from "./blocks/embed"
import ImageGallerySlider from "./blocks/image-gallery-slider"
import BookingForm from "./blocks/booking-form"
import AboutBanner from "./blocks/about-banner"
import IntroAnimation from "./blocks/intro-animation"
import BasicText from "./blocks/basic-text"
import PromoBlock from "./blocks/promo-block"
import Faq from "./blocks/faq"
import { useDebug, DebugPill } from "../../../plugins/gatsby-plugin-atollon"

/*
* Context for retaining render depth
* */
export const BlockRendererContext = React.createContext(-1)

export const RenderBlock = ({ __typename, ...props }) => {
  switch (__typename.replace("DatoCms", "")) {
    case "IntroAnimation":
      return <IntroAnimation {...props} />
    case "LandingBanner":
      return <LandingBanner {...props} />
    case "ThreeColumnItem":
      return <ThreeColumnItem {...props} />
    case "ImageTitleContentButton":
      return <ImageTitleContentButton {...props} />
    case "BasicText":
      return <BasicText {...props} />
    case "ImageBanner":
      return <ImageBanner {...props} />
    case "TitleContentBanner":
      return <TitleContentBanner {...props} />
    case "VenueArchive":
      return <VenueArchive {...props} />
    case "VenuesInteractive":
      return <VenueInteractive {...props} />
    case "TeamValueSlider":
      return <TeamValueSlider {...props} />
    case "PromoBlock":
      return <PromoBlock {...props} />
    case "StepValue":
      return <StepValue {...props} />
    case "Contact":
      return <Contact {...props} />
    case "ThankYou":
      return <ThankYou {...props} />
    case "Embed":
      return <Embed {...props} />
    case "PromoTestimonialBlock":
      return <PromoTestimonialBlock {...props} />
    case "AvailableJob":
      return <AvailableJob {...props} />
    case "AvailableFacility":
      return <AvailableFacility {...props} />
    case "AvailableSpace":
      return <AvailableSpace {...props} />
    case "EventSelector":
      return <EventSelector {...props} />
    case "ImageGallerySlider":
      return <ImageGallerySlider {...props} />
    case "BookingForm":
      return <BookingForm {...props} />
    case "AboutBanner":
      return <AboutBanner {...props} />
    case "Faq":
      return <Faq {...props} />
    default:
      return <EmptyBlock>{__typename}</EmptyBlock>
  }
}

const BlockRenderer = ({ data, className, formTitle, leadFormId }) => {
  const { showBlockNames } = useDebug()
  const existingRenderContextDepth = React.useContext(BlockRendererContext)

  return (
    <BlockRendererContext.Provider value={existingRenderContextDepth + 1}>
      {data && data.map((block) => {
        const { __typename: blockType } = block

        if (!blockType) {
          throw new Error("You must source __typename on every blocks field.")
        }

        return (
          <>
            {showBlockNames && (
              <DebugPill style={{
                position: "absolute",
              }}
              >
                {blockType}
              </DebugPill>
            )}
            <RenderBlock
              key={block.id}
              className={className}
              formTitle={formTitle}
              leadFormId={leadFormId}
              {...block}
            />
          </>
        )
      })}
    </BlockRendererContext.Provider>
  )
}

export default BlockRenderer
